import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  Spinner,
} from '@design-system';
import { WagDisclosure } from './wag-disclosure';

import { useState } from 'react';

interface LicensedConfirmationProps {
  open: boolean;
  tierName: string;
  priceUsd: number;
  onPayNow: () => void;
  onWait: () => void;
  onOpenChange: (open: boolean) => void;
  isPending: boolean;
}

export function LicensedConfirmation({
  open,
  tierName,
  priceUsd,
  onPayNow,
  onWait,
  onOpenChange,
  isPending,
}: LicensedConfirmationProps) {
  const [submitting, setSubmitting] = useState<'pay' | 'wait' | null>(null);

  function handlePayNow() {
    setSubmitting('pay');
    onPayNow();
  }

  function handleWait() {
    setSubmitting('wait');
    onWait();
  }

  return (
    <Dialog
      open={open}
      onOpenChange={next => {
        if (!isPending) onOpenChange(next);
      }}
    >
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{tierName}</DialogTitle>
          <DialogDescription>
            Someone will reach out today to discuss your planning goals.
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-col gap-3">
          <Button
            size="lg"
            onClick={handlePayNow}
            disabled={isPending}
          >
            {submitting === 'pay' && isPending && <Spinner />}
            Pay now - ${priceUsd}
          </Button>
          <Button
            size="lg"
            variant="outline"
            onClick={handleWait}
            disabled={isPending}
          >
            {submitting === 'wait' && isPending && <Spinner />}
            Wait for our team to reach out
          </Button>
        </div>

        <WagDisclosure className="text-muted-foreground text-xs leading-relaxed" />
      </DialogContent>
    </Dialog>
  );
}
